import { create } from '../../utils/create';
export class SearchInHeader {
    constructor(controller) {
        this.render = () => {
            this.searchInput = create({
                tagName: 'input',
                classNames: 'search__input',
                dataAttr: [
                    ['type', 'text'],
                    ['placeholder', 'Search'],
                    ['value', `${localStorage.getItem('searchInput') || ''}`]
                ]
            });
            this.searchInput.addEventListener('keyup', () => {
                if (this.searchInput !== null) {
                    localStorage.setItem('searchInput', this.searchInput.value);
                    this.controller.addSearching(this.searchInput.value);
                }
            });
            this.searchButton = create({
                tagName: 'button',
                classNames: 'search__button',
                children: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="search__svg">
        <path
          d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z" />
      </svg>
      `
            });
        };
        this.controller = controller;
        this.searchInput = null;
        this.searchButton = null;
    }
}
